import { Badge, Container, Row, Col, Spinner } from 'react-bootstrap';
import { useAboutPage, getAboutSectionByKey } from '@/hooks/useAboutPage';

const Timeline = ({ sectionData: propSectionData }) => {
  const { sections, loading } = useAboutPage();
  const timelineSection = propSectionData || getAboutSectionByKey(sections, 'timeline');
  
  const bgColor = timelineSection?.background_color || 'light';
  const bgEffect = timelineSection?.background_effect || null;
  let bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : 'bg-light';
  // Apply gradient effect if selected
  if (bgColor === 'primary' && bgEffect === 'gradient') {
    bgClass = 'section-bg-primary-gradient';
  }
  
  if (loading && !propSectionData) {
    return (
      <section className={`py-5 py-lg-6 ${bgClass} about-section timeline-section`}>
        <Container>
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Container>
      </section>
    );
  }
  
  const timeline = timelineSection?.items || [];
  const hasDotsEffect = bgColor === 'primary' && bgEffect === 'dots';
  
  if (!timelineSection || timeline.length === 0) {
    return null;
  }
  
  return (
    <section className={`py-5 py-lg-6 ${bgClass} about-section timeline-section ${hasDotsEffect ? 'position-relative overflow-hidden' : ''}`}>
      {hasDotsEffect && (
        <>
          <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
          <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
        </>
      )}
      <Container className={hasDotsEffect ? 'position-relative' : ''}>
        {/* Header Section */}
        <Row className="mb-4">
          <Col>
            {timelineSection.subtitle && (
              <Badge bg="primary" className="bg-opacity-10 text-primary mb-3">{timelineSection.subtitle}</Badge>
            )}
            {timelineSection.title && (
              <h2 className="sec-title mb-3">{timelineSection.title}</h2>
            )}
            {timelineSection.intro_text && (
              <p className="lead intro-text mb-0" dangerouslySetInnerHTML={{ __html: timelineSection.intro_text }} />
            )}
          </Col>
        </Row>
        <Row className="g-4">
          {timeline.map((item) => {
            const year = item.content?.year || '';
            const title = item.title || '';
            const description = item.description || '';
            
            return (
              <Col key={item.id} md={6} lg={4}>
                <div className="position-relative ps-4 pb-4 border-start border-primary">
                  <div className="position-absolute top-0 start-0 translate-middle">
                    <div className="bg-primary rounded-circle" style={{ width: '12px', height: '12px' }}></div>
                  </div>
                  <div className="mb-2">
                    <Badge bg="primary" className="bg-opacity-10 text-primary px-3 py-2">
                      {year}
                    </Badge>
                  </div>
                  <h5 className="h6 fw-bold mb-2" style={{ color: '#000000' }}>{title}</h5>
                  {description && (
                    <p className="mb-0" style={{ color: '#495057', lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: description }} />
                  )}
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default Timeline;

